import React, { useState } from 'react'
import MailboxSelector from '../box-selector'
import MAILBOX_TYPES from '../../../constants/mailbox-types'
import MessagesList from '../list-infinite'
import useMessagesInfinite from '../../../hooks/use-messages-infinite'
import MessageCompact from '../message-compact'

const MessagesMobileScreen = () => {
    const [ mailboxType, setMailboxType ] = useState(MAILBOX_TYPES.IN)
    const {
        isFetching,
        isFetchingMore,
        fetchMore,
        canFetchMore,
        messages
    } = useMessagesInfinite({ box: mailboxType })

    return (
        <React.Fragment>
            <MailboxSelector
                onMailboxTypeChange={setMailboxType}
                mailboxType={mailboxType}
            />
            <MessagesList
                messages={messages}
                messageComponent={MessageCompact}
                isLoading={isFetchingMore || isFetching}
                hasMore={canFetchMore}
                onLoadMore={() => fetchMore()}
            />
        </React.Fragment>
    )
}

export default MessagesMobileScreen